const _ = require('lodash')
export const portTypes=[{
    key:'CL_Number',
    value:'number'
  },{
    key:'CL_String',
    value:'string'
},{
    key:'CL_NArray',
    value:'narray'  
   }, {
      key: "CL_FLOW_OBJECT_SV",
      value: "FLOW_OBJECT_SV"    
  },{
    key:'CL_Date',
    value:'date'   
   
  }]


 export const getPortValue = (key)=>{
    let o = _.findWhere(portTypes, {key:key})
    return o.value
  }

 export const getPortKey = (value)=>{
    let o = _.findWhere(portTypes, {value:value})
    return o.key
  }